export default __webpack_public_path__ + "static/media/jokerPokerTableLnd.a44feefd.webp";